<template>
  <div class="dashboard-container">
    <nav class="add-navigation"></nav>
    <not-found v-if="is_found.length" />
    <template v-else>
      <div class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th class="companyName" rowspan="2">Date</th>
              <th class="client" rowspan="2">Client</th>
              <th class="vendor" rowspan="2">Vendor</th>
              <th class="postpay">Incoming SMS</th>
              <th class="contact" colspan="4">Outgoing SMS</th>
            </tr>
            <tr class="Invoice_table_header">
              <th>Count</th>
              <th>Count</th>
              <th>Sent</th>
              <th>Error</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table_div" style="width:50%;overflow-x:auto;overflow-y:hidden;margin:0 auto">
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th></th>
              <th>Count</th>
              <th>Sent</th>
              <th>Error</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
            </tr>
            <tr>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ResellersLine: () =>
      import("@/components/Charts/Reporting/ResellersLine.js"),
    CompaniesLine: () =>
      import("@/components/Charts/Reporting/CompaniesLine.js"),
    BarChart: () => import("@/components/Charts/Dashboard/BarChart.js"),
    BarChartSecond: () => import("@/components/Charts/Dashboard/BarChart2.js"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    CardComponent: () => import("@/components/CardComponent.vue"),
    Loader: () => import("@/components/Loader.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  data: () => ({
    is_found: [true],
  }),
};
</script>

<style lang="scss" scoped>
.search-div .search-input {
  width: 50%;
}

.dashboard-container {
  padding: 20px;
  .input-div {
    display: flex;
    align-items: center;
  }
  .right-wrapprr {
    display: flex;
    align-items: center;
  }
  .right-wrapprr > div {
    width: 25%;
  }
  .selects-wrapper {
    display: flex;
    align-items: center;
    background-color: #fff;
    width: 60%;
  }
  .selects-wraper {
    width: 25%;
  }
  .Bucketization {
    width: 60%;
  }

  .filter_by {
    height: 40px;
    width: 115px;
    color: #55616e;
    font-weight: 400;
    font-family: Helvetica Neue;
    font-size: 16px;
    line-height: 25px;
    padding: 10px 0 10px 30px;
  }
  .Bucketization_by {
    width: 138px;
    height: 40px;
    color: #55616e;
    font-weight: 400;
    font-family: Helvetica Neue;
    font-size: 16px;
    line-height: 25px;
    padding: 10px 0 10px 30px;
  }
  .left-wrapper {
    display: flex;
    margin-top: 20px;
  }
  .client_by {
    width: 115px;
    height: 40px;
    color: #55616e;
    font-weight: 400;
    font-family: Helvetica Neue;
    font-size: 16px;
    line-height: 25px;
    padding: 10px 0 10px 30px;
  }
  .vendor_by {
    width: 116px;
    height: 40px;
    color: #55616e;
    font-weight: 400;
    font-family: Helvetica Neue;
    font-size: 16px;
    line-height: 25px;
    padding: 10px 0 10px 30px;
  }
}

table.Invoice_table {
  width: 100%;
  margin-top: 21px;

  th {
    text-align: center;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}
table thead th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
  background: #52a8ef;
  vertical-align: inherit;
}
table thead th:nth-child(2) {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
  background: #52a8ef;
  vertical-align: inherit;
}
table thead th:nth-child(3) {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
  background: #52a8ef;
  vertical-align: inherit;
}
table,
tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}

table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  padding: 7px 10px 7px 20px;
  text-align: left;
}

tbody th:first-child {
  span {
    padding: 7px 0;
  }
}

@media (max-width: 1400px) {
  .selected-div > div {
    width: 180px;
    margin-top: 5px;
  }
  .frequently-div > div {
    width: 180px;
    margin-top: 5px;
  }
}
@media (max-width: 1300px) {
  table.Invoice_table {
    width: 1385px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

